import { DateString, DateTimeString } from 'types';
import { BomCRUDSchema, BomLine } from 'types/bom';
import {
  OrgPartSchema,
  OrgPartSchemaLite,
  PART_VERSION,
  PublicPartSchema,
  PublicPartSchemaLite,
  V2OrgPartQueryAndClientV2Types,
  V2OrgPartTypes,
} from 'types/clientV2/parts';
import {
  PurchaseRule,
  RelatedRecord,
  StockLocationLite,
  Supplier,
} from 'types/inventory';
import { Org } from 'types/org';
import { Team, TeamLite } from 'types/properties';
import { Availabilities, ShipToUserKittingOptions } from 'types/purchasing';
import { OrgSupplier } from 'types/suppliers';
import {
  DimensionClassOptions,
  UnitOfMeasureOptions,
} from 'types/unitsOfMeasure';

export const packageTypes = [
  'Axial',
  '8-SOIC',
  '0805',
  '0603',
  'SMD',
  '1206',
  'SOT-23-5',
  '16-SOIC',
  '0402',
  'Module',
  '6-CLCC',
  'SOT-23-3',
  '24-QFN',
  'MELF',
  '6-USPC',
  'SOT-25',
  '2512',
  '1210',
  '10-CLCC',
  '16-TSSOP',
  '14-SOIC',
  '20-SOIC',
  'DO-204AL (DO-41)',
  '100-TQFP',
  '8-MSOP',
  '8-PDIP',
  '100-LQFP',
  'TO-92-3',
  'DO-35 (DO-204AH)',
  '20-TSSOP',
  '64-QFN',
  '2010',
  '0201',
  '14-TSSOP',
  '8-TSSOP',
  'SOT-89-5',
  '64-LQFP',
  '28-SOIC',
  '32-QFN',
  'TO-220',
  'DO-213AA',
  'SOD-123',
  '1008',
  'DO-214AC (SMA)',
  '64-TQFP',
  '8-SO',
  'TO-220-3',
  '16-PDIP',
  '28-SSOP',
  '20-SSOP',
  'DO-35',
  '48-LQFP',
  'SOT-25-5',
  'Die',
  '1812',
  '16-QFN',
  'SSOT-24',
  'DO-41',
  'SOD-323',
  '24-SOIC',
  'TO-220AB',
  'SOT-23-6',
  '8-DIP',
  '8-DFN',
  '48-QFN',
  '20-QFN',
  'SOT-23',
  '16-SO',
  '10-MSOP',
  'D2PAK',
  '144-LQFP',
  '4-SMD',
  '6-SMD',
  '16-SSOP',
  '40-QFN',
  '10-DFN',
  'T-1 3/4',
  '2-SMD',
  '28-PLCC',
  '2-PLCC',
  '4-USPN',
  'Radial',
  '24-TSSOP',
  'SOT-323',
  '44-PLCC',
  'TO-263AB (D²PAK)',
  'Radial Lead',
  '20-PDIP',
  'DPAK',
  '44-TQFP',
  '8-VSSOP',
  '16-QSOP',
  '6-DIP',
  '8-SOP',
  '28-QFN',
  'SC-70-5',
  'SOT-23-3 (TO-236)',
  '48-TSSOP',
  'SC-82AB',
  'DO-214AB (SMC)',
  'Sub SMA',
  'SOT-23-8',
  'Mini MELF',
  '44-QFN',
  '48-TQFP',
  'DO-214AA (SMB)',
  '01005',
  '14-SO',
  '6-USPEL',
  '8-WSON',
  'DO-213AB',
  '32-LQFP',
  'DO-5',
  '100-QFP',
  '8-TDFN',
  '14-PDIP',
  '8-SMD',
  '80-LQFP',
  'SOT-89-3',
  '8-uMAX/uSOP',
  '4-USP',
  '28-TSSOP',
  '32-PLCC',
  'DO-201AD',
  'SC-70-3',
  '4-SIP',
  '120-LQFP',
  '64-QFP',
  '208-PQFP',
  '48-SSOP',
  'SOT-6',
  'TO-236AB',
  'SNT-4A',
  '20-SO',
  'TO-92',
  '1212',
  '1152-FBGA',
  'TO-220AC',
  '24-SSOP',
  '10-SIP',
  'TSOT-23-5',
  '28-PDIP',
  '24-PDIP',
  '8-SIP',
  '32-TQFP',
  '6-WSON',
  'SOD-523',
  '0612',
  'ITO-220AB',
  '0806',
  '56-TSSOP',
  '16-DIP',
  'T-1',
  '4527',
  'SOT-223',
  'USPQ-4B05',
  'SNT-6A',
  '100-LFQFP',
  '1517-FBGA',
  '4-PLCC',
  'TSOT-23-6',
  'TSOT-23-8',
  '6-DFN',
  '165-FBGA',
  'SOT-89',
  '484-FPBGA',
  'D-Pak',
  '32-VQFN',
  'SOT-223-3',
  '4-DIP',
  '144-TQFP',
  '0804',
  'DO-213AB (MELF, LL41)',
  'SOT-363',
  '48-VQFN',
  'SC-70-6',
  '64-VQFN',
  '6-SIP',
  '2835',
  '64-LFQFP',
  '68-PLCC',
  'TO-92 (TO-226)',
  '64-FBGA',
  '56-SSOP',
  'SC-70-4',
  '44-TSOP II',
  'DO-4',
  '20-TQFN',
  '256-FPBGA',
  '40-PDIP',
  '16-TQFN',
  '3030',
  'T-18',
  'TO-220-5',
  'TO-247-3',
  'TO-247',
  'DDPAK/TO-263-5',
  'TO-252',
  'D²PAK (TO-263)',
  '4-SOP',
  '18-SOIC',
  '20-PLCC',
  '5-TSOP',
  'TO-252AA',
  '0606',
  '1616',
  '484-FBGA',
  'DO-219AB (SMF)',
  '14-DIP',
];

export type PackageType = (typeof packageTypes)[number];

export type Document = {
  description?: string;
  documentType: string;
  file: string;
  url: string;
};
export type Specification = {
  id: string;
  label: string;
  value: string;
};
export type PartInfoAvailability = {
  buyableStock: number;
  quotableStock: number;
  possibleStock: number;
  timeToShip?: number;
};
export type ReferencePriceLite = {
  convertedPrice: number;
  quantity: number;
};

export enum lifecycleStatus {
  NEW = 'New',
  PRODUCTION = 'Production',
  EOL = 'EOL',
  NRFND = 'NRFND',
  OBSOLETE = 'Obsolete',
  UNKNOWN = 'Unknown',
}

export const lifeCycleStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success' | 'grey' | undefined;
    label: string;
    tooltip: string;
  };
} = {
  [lifecycleStatus.NEW]: {
    color: 'primary',
    label: 'New',
    tooltip:
      'This part has just been released or is pre-release. It may not be widely available initially.',
  },
  [lifecycleStatus.PRODUCTION]: {
    color: 'success',
    label: 'Production',
    tooltip: 'This part is currently in production',
  },
  [lifecycleStatus.EOL]: {
    color: 'error',
    label: 'End-Of-Life',
    tooltip:
      'This part is end of life and availability is limited or will become limited soon. We recommend identifying suitable alternative parts.',
  },
  [lifecycleStatus.NRFND]: {
    color: 'warning',
    label: 'Not Recommended For New Design',
    tooltip:
      'This part will be end-of-life soon and is not recommended for new designs. We recommend identifying suitable alternative parts.',
  },
  [lifecycleStatus.OBSOLETE]: {
    color: 'error',
    label: 'Obsolete',
    tooltip:
      'This part is no longer in production and availability is limited or will become limited soon. We recommend identifying suitable alternative parts.',
  },
  [lifecycleStatus.UNKNOWN]: {
    color: 'grey',
    label: 'Unknown',
    tooltip: 'The lifecycle status of this part is not known',
  },
};

export enum reachStatus {
  UNKNOWN = 'REACH Unknown',
  UNAFFECTED = 'REACH Unaffected',
  AFFECTED = 'REACH Affected',
  COMPLIANT = 'REACH Compliant',
  NONCOMPLIANT = 'REACH Non-Compliant',
}

export const reachStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success' | 'grey' | undefined;
    label: string;
    tooltip: string;
  };
} = {
  [reachStatus.UNKNOWN]: {
    color: 'grey',
    label: 'Unknown',
    tooltip: 'The REACH status of this part is not known',
  },
  [reachStatus.UNAFFECTED]: {
    color: 'success',
    label: 'Unaffected',
    tooltip: 'This part is unaffected by REACH regulations',
  },
  [reachStatus.AFFECTED]: {
    color: 'warning',
    label: 'Unaffected',
    tooltip: 'This part is affected by REACH regulations',
  },
  [reachStatus.COMPLIANT]: {
    color: 'success',
    label: 'Unaffected',
    tooltip: 'This part is compliant with REACH regulations',
  },
  [reachStatus.NONCOMPLIANT]: {
    color: 'error',
    label: 'Unaffected',
    tooltip: 'This part is not compliant with REACH regulations',
  },
};

export enum rohsStatus {
  COMPLIANT3 = 'RoHS3 Compliant',
  COMPLIANT = 'RoHS Compliant',
  COMPLIANT3_EXEMPTION = 'RoHS3 Compliant By Exemption',
  COMPLIANT_EXEMPTION = 'RoHS Compliant By Exemption',
  NONCOMPLIANT = 'RoHS Non-Compliant',
  UNKNOWN = 'RoHS Unknown',
}

export const rohsStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success' | 'grey' | undefined;
    label: string;
    tooltip: string;
  };
} = {
  [rohsStatus.NONCOMPLIANT]: {
    color: 'error',
    label: 'Non-Compliant',
    tooltip: 'This part is not RoHS compliant',
  },
  [rohsStatus.COMPLIANT]: {
    color: 'success',
    label: 'RoHS Compliant',
    tooltip: 'This part complies with RoHS',
  },
  [rohsStatus.COMPLIANT3]: {
    color: 'success',
    label: 'RoHS3 Compliant',
    tooltip: 'This part complies with RoHS3',
  },
  [rohsStatus.COMPLIANT_EXEMPTION]: {
    color: 'warning',
    label: 'RoHS Compliant By Exemption',
    tooltip: 'This part complies with RoHS via an exemption',
  },
  [rohsStatus.COMPLIANT3_EXEMPTION]: {
    color: 'warning',
    label: 'RoHS3 Compliant By Exemption',
    tooltip: 'This part complies with RoHS3 via an exemption',
  },
  [rohsStatus.UNKNOWN]: {
    color: 'grey',
    label: 'Unknown',
    tooltip: 'The RoHS status of this part is not known',
  },
};

export enum aecStatus {
  AECQ100 = 'AEC-Q100',
  AECQ101 = 'AEC-Q101',
  AECQ102 = 'AEC-Q102',
  AECQ103 = 'AEC-Q103',
  AECQ104 = 'AEC-Q104',
  AECQ200 = 'AEC-Q200',
  AECQ001 = 'AEC-Q001',
  AECQ002 = 'AEC-Q002',
  AECQ003 = 'AEC-Q003',
  AECQ004 = 'AEC-Q004',
  AECQ005 = 'AEC-Q005',
  AECQ006 = 'AEC-Q006',
  UNKNOWN = 'AEC-Q Unknown',
}

export const aecStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success' | 'grey' | undefined;
    label: string;
    tooltip: string;
  };
} = {
  [aecStatus.AECQ100]: {
    color: 'success',
    label: 'AEC-Q100',
    tooltip: 'This part complies with AEC-Q100',
  },
  [aecStatus.AECQ101]: {
    color: 'success',
    label: 'AEC-Q101',
    tooltip: 'This part complies with AEC-Q101',
  },
  [aecStatus.AECQ102]: {
    color: 'success',
    label: 'AEC-Q102',
    tooltip: 'This part complies with AEC-Q102',
  },
  [aecStatus.AECQ103]: {
    color: 'success',
    label: 'AEC-Q103',
    tooltip: 'This part complies with AEC-Q103',
  },
  [aecStatus.AECQ104]: {
    color: 'success',
    label: 'AEC-Q104',
    tooltip: 'This part complies with AEC-Q104',
  },
  [aecStatus.AECQ200]: {
    color: 'success',
    label: 'AEC-Q200',
    tooltip: 'This part complies with AEC-Q200',
  },
  [aecStatus.AECQ001]: {
    color: 'success',
    label: 'AEC-Q001',
    tooltip: 'This part complies with AEC-Q001',
  },
  [aecStatus.AECQ002]: {
    color: 'success',
    label: 'AEC-Q002',
    tooltip: 'This part complies with AEC-Q002',
  },
  [aecStatus.AECQ003]: {
    color: 'success',
    label: 'AEC-Q003',
    tooltip: 'This part complies with AEC-Q003',
  },
  [aecStatus.AECQ004]: {
    color: 'success',
    label: 'AEC-Q004',
    tooltip: 'This part complies with AEC-Q004',
  },
  [aecStatus.AECQ005]: {
    color: 'success',
    label: 'AEC-Q005',
    tooltip: 'This part complies with AEC-Q005',
  },
  [aecStatus.AECQ006]: {
    color: 'success',
    label: 'AEC-Q006',
    tooltip: 'This part complies with AEC-Q006',
  },
  [aecStatus.UNKNOWN]: {
    color: 'grey',
    label: 'Unknown',
    tooltip: 'The AEC-Q status of this part is not known',
  },
};

export enum factoryLeadDayStatus {
  THREE_MONTHS = '<3 Months',
  SIX_MONTHS = '3-6 Months',
  ONE_YEAR = '6-12 Months',
  MORE = '>12 Months',
}

export const factoryLeadDayStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success';
    label: string;
    tooltip: string;
  };
} = {
  [factoryLeadDayStatus.THREE_MONTHS]: {
    color: 'success',
    label: '<3 Months',
    tooltip:
      'The median distributor-reported factory lead time for this part is <3 months',
  },
  [factoryLeadDayStatus.SIX_MONTHS]: {
    color: 'primary',
    label: '3-6 Months',
    tooltip:
      'The median distributor-reported factory lead time of this part is 3-6 months',
  },
  [factoryLeadDayStatus.ONE_YEAR]: {
    color: 'warning',
    label: '6-12 Months',
    tooltip:
      'The median distributor-reported factory lead time of this part is 6-12 months. We recommend identifying suitable alternative parts with current availability or a shorter lead time.',
  },
  [factoryLeadDayStatus.MORE]: {
    color: 'error',
    label: '>12 Months',
    tooltip:
      'The median distributor-reported factory lead time of this part is >12 months. We recommend identifying suitable alternative parts with current availability or a shorter lead time.',
  },
};

export enum minLeadStatus {
  THREE_DAYS = '<=3 Days',
  ONE_WEEK = '< 1 Week',
  ONE_MONTH = '< 1 Month',
  MORE = '>1 Month',
}

export const minLeadStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success';
    label: string;
    tooltip: string;
  };
} = {
  [minLeadStatus.THREE_DAYS]: {
    color: 'success',
    label: '<=3 Days',
    tooltip: 'The shortest distributor lead time for this part is <=3 days',
  },
  [minLeadStatus.ONE_WEEK]: {
    color: 'primary',
    label: '< 1 Week',
    tooltip: 'The shortest distributor lead time for this part is <1 week',
  },
  [minLeadStatus.ONE_MONTH]: {
    color: 'warning',
    label: '< 1 Month',
    tooltip: 'The shortest distributor lead time for this part is <1 month',
  },
  [minLeadStatus.MORE]: {
    color: 'error',
    label: '>1 Month',
    tooltip:
      'The shortest distributor lead time for this part is >1 month. We recommend identifying suitable alternative parts with current availability or a shorter lead time.',
  },
};

export enum multiSourcingStatus {
  TWO = '<2',
  FIVE = '2-4',
  TEN = '5-9',
  MORE = '>10',
}

export const multiSourcingStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success';
    label: string;
    tooltip: string;
  };
} = {
  [multiSourcingStatus.TWO]: {
    color: 'error',
    label: '<2',
    tooltip:
      'Fewer than 2 authorized distributors report stocking this part, so mid-to-long term supply chain stability is very much in question. We recommend proactively finding alternatives for this part or, if none can be found, selecting a comparable part with more sourcing flexibility.',
  },
  [multiSourcingStatus.FIVE]: {
    color: 'warning',
    label: '2-4',
    tooltip:
      'Only 2-4 authorized distributors report stocking this part, so mid-to-long term supply chain risk may be elevated. We recommend proactively finding alternatives for this part or, if none can be found, selecting a comparable part with more sourcing flexibility.',
  },
  [multiSourcingStatus.TEN]: {
    color: 'primary',
    label: '5-9',
    tooltip: '5-9 authorized distributors report stocking this part.',
  },
  [multiSourcingStatus.MORE]: {
    color: 'success',
    label: '>10',
    tooltip: '10 or more authorized distributors report stocking this part.',
  },
};

export const multiSourcingStatusCurrentFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success';
    label: string;
    tooltip: string;
  };
} = {
  [multiSourcingStatus.TWO]: {
    color: 'error',
    label: '<2',
    tooltip:
      'Fewer than 2 authorized distributors report current stock of this part so there is a significantly elevated risk of shortages.',
  },
  [multiSourcingStatus.FIVE]: {
    color: 'warning',
    label: '2-4',
    tooltip:
      'Only 2-4 authorized distributors report current stock of this part so there is an elevated risk of shortages.',
  },
  [multiSourcingStatus.TEN]: {
    color: 'primary',
    label: '5-9',
    tooltip: '5-9 authorized distributors report current stock of this part.',
  },
  [multiSourcingStatus.MORE]: {
    color: 'success',
    label: '>10',
    tooltip:
      '10 or more authorized distributors report current stock of this part.',
  },
};

export enum stockStatus {
  STRONG = 'Strong',
  OKAY = 'Okay',
  LIMITED = 'Limited',
  SHORTAGE = 'Shortage',
}

export const stockStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success';
    label: string;
    tooltip: string;
  };
} = {
  [stockStatus.STRONG]: {
    color: 'success',
    label: 'High',
    tooltip:
      '50,000 or more of this part are currently buyable from authorized distributors.',
  },
  [stockStatus.OKAY]: {
    color: 'primary',
    label: 'Stable',
    tooltip:
      '10,000-50,000 of this part are currently buyable from authorized distributors.',
  },
  [stockStatus.LIMITED]: {
    color: 'warning',
    label: 'Limited',
    tooltip:
      '1,000-10,000 of this part are currently buyable from authorized distributors. We recommend purchasing enough stock to cover your near-to-mid-term requirements as soon as possible.',
  },
  [stockStatus.SHORTAGE]: {
    color: 'error',
    label: 'Shortage',
    tooltip:
      'Fewer than 1,000 of this part are currently buyable from authorized distributors. We recommend identifying alternative parts and/or suppliers.',
  },
};

export enum historicalProcurabilityStatus {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export const historicalProcurabilityStatusFormats: {
  [key: string]: {
    color: 'warning' | 'error' | 'success';
    tooltip: string;
  };
} = {
  [historicalProcurabilityStatus.HIGH]: {
    color: 'success',
    tooltip:
      'This parts stock level has consistently met or exceeded the Estimated Annual Usage (EAU) over the past year.',
  },
  [historicalProcurabilityStatus.MEDIUM]: {
    color: 'warning',
    tooltip:
      'This parts stock level has often met the Estimated Annual Usage (EAU) over the past year.',
  },
  [historicalProcurabilityStatus.LOW]: {
    color: 'error',
    tooltip:
      'This parts stock level has been below the Estimated Annual Usage (EAU) over the past year.',
  },
};

export enum estimatedDaysOfSupplyStatus {
  STRONG = 'Strong',
  OKAY = 'Okay',
  LIMITED = 'Limited',
  SHORTAGE = 'Shortage',
}

export const estimatedDaysOfSupplyFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success';
    tooltip: (daysOrWeeksValue: string) => string;
  };
} = {
  [estimatedDaysOfSupplyStatus.STRONG]: {
    color: 'success',
    tooltip: (daysOrWeeksValue) =>
      `This part is estimated to be available for ${daysOrWeeksValue}`,
  },
  [estimatedDaysOfSupplyStatus.OKAY]: {
    color: 'primary',
    tooltip: (daysOrWeeksValue) =>
      `This part is estimated to be available for ${daysOrWeeksValue}`,
  },
  [estimatedDaysOfSupplyStatus.LIMITED]: {
    color: 'warning',
    tooltip: (daysOrWeeksValue) =>
      `This part is estimated to be available for ${daysOrWeeksValue}`,
  },
  [estimatedDaysOfSupplyStatus.SHORTAGE]: {
    color: 'error',
    tooltip: (daysOrWeeksValue) =>
      `This part is estimated to be available for ${daysOrWeeksValue}`,
  },
};

export enum probableAvailabilityWindowStatus {
  STRONG = 'Strong',
  OKAY = 'Okay',
  LIMITED = 'Limited',
  SHORTAGE = 'Shortage',
}

export const probableAvailabilityWindowStatusFormats: {
  [key: string]: {
    color: 'warning' | 'primary' | 'error' | 'success';
    tooltip: (daysOrWeeksValue: string) => string;
  };
} = {
  [probableAvailabilityWindowStatus.STRONG]: {
    color: 'success',
    tooltip: (daysOrWeeksValue) =>
      `The total global stock for this part is predicted to remain above the EAU value for ${daysOrWeeksValue} days, including predicted restock events.`,
  },
  [probableAvailabilityWindowStatus.OKAY]: {
    color: 'primary',
    tooltip: (daysOrWeeksValue) =>
      `The total global stock for this part is predicted to remain above the EAU value for ${daysOrWeeksValue} days, including predicted restock events.`,
  },
  [probableAvailabilityWindowStatus.LIMITED]: {
    color: 'warning',
    tooltip: (daysOrWeeksValue) =>
      `The total global stock for this part is predicted to remain above the EAU value for ${daysOrWeeksValue} days, including predicted restock events.`,
  },
  [probableAvailabilityWindowStatus.SHORTAGE]: {
    color: 'error',
    tooltip: (daysOrWeeksValue) =>
      `The total global stock for this part is predicted to remain above the EAU value for ${daysOrWeeksValue} days, including predicted restock events.`,
  },
};

export type Part = {
  id: string;
  internalId: string;
  customId?: string;
  mpn: string;
  mfg: string;
  classification: string;
  heroImage: string;
  description: string;
  totalAvailability: PartInfoAvailability;
  availability: PartInfoAvailability;
  documents?: Document[];
  altMpns?: string[];
  specifications?: Specification[];
  dataAge: DateString;
  expected?: number;
  processing?: number;
  onHand?: number;
  total?: number;
  refPrice10?: number;
  refPrice100?: number;
  refPrice1000?: number;
  refPrice10000?: number;
  buyableRefPrice10?: number;
  buyableRefPrice100?: number;
  buyableRefPrice1000?: number;
  buyableRefPrice10000?: number;
  minLead?: number;
  buyableReferencePrices?: ReferencePriceLite[];
  referencePrices?: ReferencePriceLite[];
  package?: string | null;
  terminations?: number;
  terminationType?: string | null;
  deprecatedIds?: string[];
  msl?: string;
  lifecycleStatus?: lifecycleStatus | null;
  lastSyncedAt?: DateTimeString;
  deprecatedBy?: string | null;
  relatedBomCount?: number;
  relatedPurchaseCount?: number;
  relatedStockLotCount?: number;
  relatedQuoteCount?: number;
  medianFactoryLeadDays?: number;
  numAuthedDistributorsWithOffers?: number;
  numAuthedDistributorsWithOffersCurrentStock?: number;
  numDistributorsWithOffersCurrentStock?: number;
  isCustomizedInfo?: boolean;
  v2OrgPartId?: OrgPartSchema['id'];
  v2OrgPart?: OrgPartSchema['id'];
  publicPart?: PublicPartSchema['id'];
  isElectronicComponent?: boolean;
  buyable?: number; // This typing is incorrect, but needed for now. LIF-36 will update BomLine part typing to OrgPart
  revision?: string;
  partType?: string;
  dimensionClass?: DimensionClassOptions;
  preferredUnit?: UnitOfMeasureOptions;
  mfgAliases?: string[];
};

export const specialCpids: { [key: string]: string } = {
  XX000000000P: 'Unknown MPN - Electronic Component',
  XX000000000H: 'Unknown MPN - Hardware',
  XX000000000M: 'Unknown MPN - Mixed Parts',
  XX000000FIXT: 'Programming/Test Fixture',
  XX000000PACK: 'Packaging',
  XX000000CUST: 'Misc Customer Item',
  XX000000STNC: 'SMT Stencil',
  XX000000BARE: 'Bare PCB',
  XX000000PCBA: 'PCB Assembly',
  XX000000DUMP: 'Pick & Place Dump Bag',
};

export type PartInventoryQuerySchema = {
  id: string;
  part: Part;
  orgPart: OrgPart;
  expected: number;
  processing: number;
  onHand: number;
  inTransit: number;
  atRest: number;
  allocated: number;
  unallocated: number;
  allocatedToRun: number;
  total: number;
  partVersion?: PART_VERSION;
} & Pick<V2OrgPartQueryAndClientV2Types, 'v2OrgPart'>;

// Type returned from API
export type NoPartInventory = {
  part: string;
  // 11/16/23 --> Not currently being returned by flagship, but should be
  // in practice, should not be undefined, but setting it as a potential for now
  orgPart?: string;
  expected: number;
  processing: number;
  allocated: number;
  allocatedToRun?: number;
  onHand: number;
  unallocated?: number;
  total: number;
  facility?: StockLocationLite;
} & Pick<V2OrgPartTypes, 'v2OrgPart'>;

export type NoPartInventoryWithLocation = NoPartInventory & {
  locationDetail: NoPartInventory[];
};

export type PartPrice = {
  price: number;
  priceBreak: number;
};

export type PartQuote = {
  id: string;
  part: Part;
  status: string;
  method: string;
  quant: number;
  submittedAt: string;
  expiresAt: string;
  moq: number;
  multiple: number;
  maximum: number;
  lead: number;
  additionalPercentage: string;
  additionalFlat: string;
  shipping: string;
  prices: PartPrice[];
  org: Org['id'];
  solicitation: Solicitation;
  supplier: Supplier;
  orgSupplier: OrgSupplier;
  supplierConversationId: string;
  link: string;
  shipsFromCountry: string;
  externalNotes?: string;
  internalNotes?: string;
  authorized?: boolean;
  team?: TeamLite;
};

export type PartQuoteCreateUpdate = {
  quant?: number;
  method?: string;
  submittedAt?: string;
  expiresAt?: string;
  additionalPercentage?: string;
  additionalFlat?: string;
  shipping?: string;
  externalNotes?: string;
  internalNotes?: string;
  prices?: PartPrice[];
  moq?: number;
  multiple?: number;
  maximum?: number;
  lead?: number;
  solicitation?: Solicitation['id'];
  orgSupplier?: OrgSupplier['id'];
  supplierConversationId?: string;
  link?: string;
  requestStatus?: string;
  receivedAt?: string;
  authorized?: boolean;
  team?: Team['id'];
} & (
  | {
      part: Part['id'];
      v2OrgPart?: never;
    }
  | { part?: never; v2OrgPart: OrgPartSchema['id'] }
);

export type PriceBreak = {
  priceBreak: number;
  price: number;
};

export type PartOfferCorrection = {
  correctValue: number | string | PriceBreak[];
  originalValue: number | string | PriceBreak[];
  detail: string | null;
  created_at: DateTimeString;
};

export enum OfferType {
  QUOTE = 'quote',
  OFFER = 'offer',
  SUPPLIER_QUOTE = 'supplier_quote_line',
}

export const offerTypeLabels = {
  [OfferType.QUOTE]: 'Quote',
  [OfferType.OFFER]: 'Supplier Offer',
  [OfferType.SUPPLIER_QUOTE]: 'Quote',
};

export type PartOffer = {
  id?: string;
  part: string;
  reportedStock: number;
  lead: number;
  moq: number;
  multiple: number;
  country: string | null;
  authorized: boolean;
  foreignCurrency: boolean;
  prices: PriceBreak[];
  supplier: Supplier;
  factoryLeadDays?: number;
  corrections?: { [key: string]: PartOfferCorrection };
  isBackordered?: boolean;
  isUncertainLead?: boolean;
  sku?: string | null;
  customReelSku?: string | null;
  package?: string | null;
  link?: string | null;
  offerType?: OfferType;
  duties?: string | null; // This will only be present on offers derived from supplier quote lines
  shipping?: string | null; // This will only be present on offers derived from supplier quote lines
  otherTotal?: string | null; // This will only be present on offers derived from supplier quote lines
  bulkQuant?: number; // This will only be present on offers derived from supplier quote lines
  dimensionUnit?: UnitOfMeasureOptions; // This will only be present on offers derived from supplier quote lines
  dimensionClass?: DimensionClassOptions; // This will only be present on offers derived from supplier quote lines
  dimensionValue?: number; // This will only be present on offers derived from supplier quote lines
};

export type SolicitationCreate = {
  id?: string; // only used for updating
  /** --------------------------------- */
  /** --- Deprecated Part V1 Fields --- */
  /** --------------------------------- */
  part?: string;
  /** -------------------------- */
  /** --- New Part V2 Fields --- */
  /** -------------------------- */
  v2OrgPart: V2OrgPartTypes['v2OrgPart'];
  /** ------------------------ */
  /** --- Remaining Fields --- */
  /** ------------------------ */
  orgId: string;
  targetQuant: number;
  targetPrice?: string | undefined;
  // notes from customer to cofactr
  notes?: string;
  needBy: string | undefined;
  productionRun?: string | null;
  // for solicitations only: notes related to the request for Cofactr logistics
  // but not for the customer to view
  externalNotes?: string;
  team?: Team['id'];
};

export type Solicitation = {
  id: string;
  status: string;
  targetQuant: number;
  targetPrice: string;
  needBy: string;
  submittedAt: string;
  processedAt: string;
  completedQuoteCount: string;
  totalQuoteCount: string;
  requestNotes: string;
  notes: string;
  part: Part['id'];
  quotes: PartQuote[] | null;
  lowestQuotePrice: number | null;
  relatedRecords?: RelatedRecord[];
  team: TeamLite;
  /** -------------------------- */
  /** --- New Part V2 Fields --- */
  /** -------------------------- */
  partVersion: PART_VERSION;
  v2OrgPart: OrgPartSchema['id'];
};

export type PartRequest = {
  requestLineId?: string;
  part: string;
  quant: number;
  alts?: string[];
  alwaysAllowSources?: string[];
  limitToSources?: string[];
} & Pick<V2OrgPartTypes, 'v2OrgPart' | 'altV2OrgParts'>;

export enum MatchType {
  FORM_FIT_FUNCTION = 'Form Fit Function',
  UNKNOWN = 'Unknown',
  IDENTICAL = 'Identical',
  OTHER = 'Other',
}

export type ExpandedAlternativePart = {
  originalPartId?: string;
  part: Part;
  sourceType: string;
  publicPart: PublicPartSchemaLite['id'] | null;
  matchType: MatchType;
  v2OrgPart: OrgPartSchemaLite['id'] | null;
};

export enum AltSourceType {
  USED_IN_BOM = 'used_in_bom',
  SAME_CUSTOM_PN = 'same_cpn',
  FROM_SUPPLIER = 'supplier',
  MPN_SEARCH = 'mpn_search',
  PARAMETRIC_SEARCH = 'parametric_search',
  COMMUNITY = 'other_accounts',
  ALTAI = 'cofactr_ai',
}

export const sourceTypeOptions = [
  'Used in BOM',
  'Same Custom PN',
  'From Supplier',
  'MPN Search',
  'Parametric Search',
  'Community',
  'AltAI',
];

/**
 * Alt Parts returned when fetching PartAlts via describe_parts
 *
 * @property {string} [originalPartId] - The CPID of the original part this alt suggested for
 * @property {PartId} part - The CPID of the suggested alt.
 * @property {string} sourceType - The source type of the alt suggestion.
 * @property {string} matchType - The match type of the alt suggestion.
 * @property {string|null} [publicPart] - The UUID of the public part. Theoretically should never be null, but could not be guaranteed on Flagship side.
 * @property {string|null} [v2OrgPart] - The UUID of the V2 OrgPart associated with the PublicPart, if there is one for this org.
 */
export type ExpandedAlternativePartDescribeParts = {
  originalPartId?: string;
  part: PartId;
  sourceType: AltSourceType;
  publicPart: PublicPartSchemaLite['id'] | null;
  matchType: MatchType;
  v2OrgPart: OrgPartSchemaLite['id'] | null;
  classification: PartCore['classification'];
  customId: PartCore['customId'];
  mpn: PartCore['mpn'];
  manufacturer: PartCore['mfg'];
  description: PartCore['description'];
  heroImage: PartCore['heroImage'];
  lifecycleStatus: PartCore['lifecycleStatus'];
};

export type AvailabilitiesRequest = ShipToUserKittingOptions & {
  orgId?: string;
  partRequests: PartRequest[];
  authorizedOnly?: boolean;
  maxLead?: number;
  addOverage?: boolean;
  subtractExpectedStock?: boolean;
  subtractProcessingStock?: boolean;
  subtractOnhandStock?: boolean;
  supplierIds?: Supplier['id'][];
  requiredCertifications?: string[];
  backorderOnly?: boolean;
  internationalDestination?: boolean;
  purchaseRule?: PurchaseRule['id'];
  bom?: BomCRUDSchema['id'];
};

export type AvailabilitiesReturnV2 = {
  buyableAvailability: Availabilities;
  partialBackorderAvailability: Availabilities;
  fullBackorderAvailability: Availabilities;
};

export type CreateAvailabilitiesSnapshotRequest = AvailabilitiesRequest & {
  selectedLead: number;
  productionRun?: string | null;
  dropShip?: boolean;
  forceDropShip?: boolean;
};

export enum PartOptionStatus {
  INVENTORY = 'inventory',
  QUOTABLE = 'quotable',
  MAYBE = 'maybe',
  NEED_TO_FIND = 'need_to_find',
  BUYABLE = 'buyable',
}

export type PartOption = {
  requestLineId: string | null | BomLine;
  status: PartOptionStatus;
  id: string;
  quant: number;
  totalQuant: number;
  purchaseQuant: number;
  unitPrice: number;
  totalPrice: number;
  landedPrice: number;
  minimumLead: number;
  breakdown: PartOptionBreakdown[];
  part: Part;
  v2OrgPart?: OrgPartSchema | null;
};

export type PartOptionBreakdown = {
  sourceId: string;
  sourceName: string;
  id: string;
  purchaseQuant: number;
  unitPrice: number;
  totalPrice: number;
  landedPrice: number;
  isBackordered?: boolean;
  isUncertainLead?: boolean;
  expectedShipsIn?: number;
  expectedTransitTime?: number;
  bestCaseLead?: number;
  allowDropship?: boolean;
  sku?: string;
};

export type CreateCustomPartRequest = {
  mpn: string;
  customId?: string;
  mfg?: string;
  customMfg?: string;
  classification?: string;
  customClassification?: string;
  description?: string;
  // TODO: add specific typing for value of packageValueOptions
  package?: string;
  terminations?: number;
  // TODO: add specific typing for value of terminationTypeValues
  terminationType?: string;
};

export type UpdatePartRequest = {
  customId?: string;
  description?: string;
  package?: string;
  terminationType?: string;
  // todo: make typeof lifecycleStatus options
  lifecycleStatus?: string;
};

export type Manufacturer = {
  id: string;
  label: string;
};

export type PublicManufacturerSchema = {
  id: string;
  cofactrId: string;
  name: string;
};

export type Classification = { id: string; label: string };

export type PartRaw = {
  altMpns?: string | string[];
  description?: string;
  lineNumber?: string;
  mfg?: string;
  manufacturer?: string;
  mpn?: string;
  quant?: number;
  refdes?: string;
  value?: string;
  linenum?: string;
  link?: string;
  customId?: string;
  package?: string;
  mountType?: string;
};

export enum ActionTypes {
  pause = 'pause',
  start = 'start',
  delete = 'delete',
}

export enum TerminationTypeValues {
  OTHER = 'other',
  SMT = 'SMT',
  THT = 'THT',
  PRESSED_FIT = 'pressed fit',
  HYBRID_OF_SMT_AND_THT = 'hybrid of SMT and THT',
  HYBRID_OF_PRESSED_FIT_AND_SMT = 'hybrid of pressed fit and SMT',
  HYBRID_OF_PRESSED_FIT_AND_THT = 'hybrid of pressed fit and THT',
}

export type TerminationTypeOption = {
  value: TerminationTypeValues;
  label: string;
};

export const terminationTypeOptionsExpanded: TerminationTypeOption[] = [
  { label: 'Other', value: TerminationTypeValues.OTHER },
  { label: 'SMT', value: TerminationTypeValues.SMT },
  { label: 'THT', value: TerminationTypeValues.THT },
  { label: 'Pressed fit', value: TerminationTypeValues.PRESSED_FIT },
  {
    label: 'Hybrid of SMT and THT',
    value: TerminationTypeValues.HYBRID_OF_SMT_AND_THT,
  },
  {
    label: 'Hybrid of pressed fit and SMT',
    value: TerminationTypeValues.HYBRID_OF_PRESSED_FIT_AND_SMT,
  },
  {
    label: 'Hybrid of pressed fit and THT',
    value: TerminationTypeValues.HYBRID_OF_PRESSED_FIT_AND_THT,
  },
];

export type PartId = string;

export type PartCore = {
  id: PartId;
  customId: string | null;
  mpn: string | null;
  classification: string | null;
  description: string | null;
  lifecycleStatus: lifecycleStatus | null;
  heroImage: string | null;
  mfg: string | null;
  package: string | null;
  terminations: string | null;
  terminationType: string;
  deprecatedBy: string | null;
  msl: string | null;
  isCustomizedInfo: boolean;
  altMpns: string[];
  mfgAliases?: string[];
  buyable?: number;
  multisourcing?: number;
  currentMultisourcing?: number;
  minLead?: number;
  factoryLead?: number;
  reach?: string;
  rohs?: string;
  aec?: string;
  htsus?: string | null;
  coo?: string | null;
  dimensionClass: DimensionClassOptions | null;
  preferredUnit: UnitOfMeasureOptions | null;
} & Pick<V2OrgPartTypes, 'v2OrgPart'>;

export type PartAlts = {
  id: PartId;
  alts: ExpandedAlternativePartDescribeParts[];
};

export type PartSpecs = {
  id: PartId;
  specifications: Specification[];
  documents: Document[];
};

export enum MarketRating {
  RED = 'RED',
  AMBER = 'AMBER',
  GREEN = 'GREEN',
}

export type MarketAvailability = {
  inventoryLevel: number;
  observedAt: DateTimeString;
};

export type PartMarket = {
  id: PartId;
  mfr: string;
  historicalProcurability: number;
  marketAvailabilities: MarketAvailability[];
  estimatedDaysOfSupply: number;
  probableAvailabilityWindow: number;
  rating: keyof typeof MarketRating;
};

export enum RetryDirective {
  pass = 'pass',
  retry_now = 'retry_now',
  no_retry = 'no_retry',
}

export type PartSupply = {
  id: PartId;
  buyable: number;
  quotable: number;
  maybe: number;
  minLead: number;
  medianFactoryLeadDays: number;
  numAuthedDistributorsWithOffers: number;
  numAuthedDistributorsWithOffersCurrentStock: number;
  numDistributorsWithOffersCurrentStock: number;
  refPrice10: number;
  refPrice100: number;
  refPrice1000: number;
  refPrice10000: number;
  buyableRefPrice10: number;
  buyableRefPrice100: number;
  buyableRefPrice1000: number;
  buyableRefPrice10000: number;
  referencePrices: ReferencePrice[];
  buyableReferencePrices: ReferencePrice[];
  offers: Offer[];
  dataAge: DateString;
  retryDirective?: RetryDirective;
  v2OrgPartId?: OrgPartSchema['id'];
};

export type PartReduxCache = {
  core: PartCore | null;
  supply: PartSupply | null;
  alts: PartAlts | null;
  specs: PartSpecs | null;
  market: PartMarket | null;
  suggestions: PartSuggestions | null;
};

export type Offer = {
  id?: string | null;
  reportedStock: number;
  lead: number;
  moq: number;
  multiple: number;
  country: string | null;
  authorized: boolean;
  foreignCurrency: boolean;
  factoryLeadDays: number;
  isBackordered: boolean;
  isUncertainLead: boolean;
  supplier: PartOfferSupplier;
  corrections: { [key: string]: PartOfferCorrection };
  prices: PartPrice[];
  sku?: string | null;
  customReelSku?: string | null;
  package?: string | null;
  offerType?: OfferType;
  v2OrgPartId?: OrgPartSchema['id'];
  extraLeadDays?: number;
  duties?: string | null; // This will only be present on offers derived from supplier quote lines
  shipping?: string | null; // This will only be present on offers derived from supplier quote lines
  otherTotal?: string | null; // This will only be present on offers derived from supplier quote lines
  bulkQuant?: number; // This will only be present on offers derived from supplier quote lines
  dimensionUnit?: UnitOfMeasureOptions; // This will only be present on offers derived from supplier quote lines
  dimensionClass?: DimensionClassOptions; // This will only be present on offers derived from supplier quote lines
  dimensionValue?: number; // This will only be present on offers derived from supplier quote lines
} & Pick<V2OrgPartTypes, 'v2OrgPart'>;

export type OfferWithPartId = Offer & {
  partId: PartId;
  v2OrgPartId?: OrgPartSchema['id'];
};

type PartOfferSupplier = {
  id: string;
  name: string;
  authenticity: number;
  accuracy: number;
  certifications: string[];
  buyable: boolean;
  shippingOptions: ShippingLead[];
  freeShip: string | null;
  bestCaseLead: number | null;
  lead: number | null;
};

export type ReferencePrice = {
  quantity: number;
  price: number;
  currency: string;
  convertedCurrency: string;
  convertedPrice: number;
  conversionRate: number;
};

type ShippingLead = {
  price: number;
  shippingLead: number;
};

export type OrgPart = PartCore & {
  part: PartCore;
  customId?: string;
  // NOTE: omitting this for the time being due to this FF https://cofactr.slack.com/archives/C054R6HNSTA/p1729098693828559
  // bomCount?: number;
  // purchaseCount?: number;
  // stockLotCount?: number;
  // quoteCount?: number;
  customProperties?: object;
};

export type PartSuggestionRelatedPart = Pick<
  PartCore,
  | 'mpn'
  | 'description'
  | 'classification'
  | 'customId'
  | 'heroImage'
  | 'lifecycleStatus'
> & {
  part: string;
  v2OrgPart: string | null;
  publicPart: string | null;
  manufacturer: PartCore['mfg'];
  relationshipType: string;
  relationshipReason: string | null;
};

export type PartSuggestion = {
  suggestionId: string;
  suggestionType: string;
  confidence: string;
  priority: number;
  title: string;
  description: string;
  reasoning: string;
  relatedParts: PartSuggestionRelatedPart[];
  metadata: Record<string, unknown>;
};

export type PartSuggestions = {
  id: string;
  cofactrId: string;
  v2OrgPartId: string;
  suggestions: PartSuggestion[];
};
